import React from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

interface SimulatorVPLData {
  vplAnual: number[];
  economyAnual: number[];
  economyAccumulated: number[];
}

export function getSimulationSeries(
  data: SimulatorVPLData,
  construindoUsina: boolean,
  construindoBateria: boolean,
  accumulated: boolean
) {
  if (construindoUsina || construindoBateria) return data.vplAnual.slice(1);
  if (accumulated) return data.economyAccumulated;
  return data.economyAnual;
}

export function getSimulationCategories(series: number[]) {
  return Array.from({ length: series.length }, (_, i) => `Ano ${i + 1}`);
}

function SimulatorVPL({
  data,
  construindoUsina,
  construindoBateria,
  accumulated = false,
}: {
  data: SimulatorVPLData;
  construindoUsina: boolean;
  construindoBateria: boolean;
  accumulated?: boolean;
}) {
  const simulationSeries = getSimulationSeries(
    data,
    construindoUsina,
    construindoBateria,
    accumulated
  );

  const chartOptions = {
    chart: { type: "column", backgroundColor: "#FAFAFA", borderRadius: "8px" },
    title: { text: "", align: "left" },
    xAxis: {
      categories: getSimulationCategories(simulationSeries),
    },
    yAxis: { title: { text: "Valor em R$" }, gridLineWidth: 0 },
    credits: {
      enabled: false,
    },
    plotOptions: {
      column: {
        borderRadius: "0%",
      },
    },
    tooltip: {
      formatter: function (
        this: Highcharts.TooltipFormatterContextObject
      ): string {
        return `<b>${this.x}<br>${this.y.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        })}</b>`;
      },
    },
    series: {
      label: { enabled: true },
      data: simulationSeries,
      zones: [
        {
          value: 0,
          color: "#f91010",
        },
        {
          color: "#1fa824",
        },
      ],
    },
    legend: {
      enabled: false,
    },
  };

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
}

export default SimulatorVPL;
